import { styled } from "@mui/material/styles";
import { TooltipProps as MuiTooltipProps } from "@mui/material/Tooltip";
import { black, grey } from "designSystem/styles/color";
import { Box, Text } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { NO_WRAP, TEXT_CLAMP } from "designSystem/styles/style-functions";
import HtmlTooltip from "designSystem/components/tooltip/HtmlTooltip";
import { C8Node } from "csi/typings";
import React, { FunctionComponent } from "react";

const PREFIX = "BOMDetailsTooltip";

const classes = {
	noWrap: `${PREFIX}noWrap`,
	textClamp: `${PREFIX}textClamp`,
	tooltipNodeType: `${PREFIX}tooltipNodeType`,
	tooltipNodeValue: `${PREFIX}tooltipNodeValue`,
};

const StyledBox = styled(Box)((
	{
		theme,
	},
) => ({
	maxWidth: 380,

	[`& .${classes.noWrap}`]: {
		...NO_WRAP,
	},
	[`& .${classes.textClamp}`]: {
		...TEXT_CLAMP(3),
	},
	[`& .${classes.tooltipNodeType}`]: {
		color: grey[900],
	},
	[`& .${classes.tooltipNodeValue}`]: {
		color: black[100],
	},
}));

export interface BOMDetailsTooltipProps extends Omit<MuiTooltipProps, "title"> {
	/** product node */
	productNode: C8Node;
	/** Hierarchy nodes */
	ancestorNodes: C8Node[];
};

const BOMDetailsTooltip: FunctionComponent<BOMDetailsTooltipProps> = (props) => {
	const { children, productNode, ancestorNodes } = props;

	const loc = useLocale();

	const {
		noWrap,
		textClamp,
		tooltipNodeType,
		tooltipNodeValue,
	} = classes;

	return (
		<HtmlTooltip
			placement="bottom-start"
			title={(
				<StyledBox>
					<Text
						bold
						className={textClamp}
						text={loc.getNodeName(productNode)}
					/>
					{ancestorNodes.slice(0, 4).map((node) => (
						<Box
							className={noWrap}
							key={node.$URL}
						>
							<Text
								className={tooltipNodeType}
								noWrap
								text={`${loc.type(node.$Type)}: `}
							/>
							<Text
								className={tooltipNodeValue}
								noWrap
								text={loc.getNodeName(node)}
							/>
						</Box>
					))
					}
				</StyledBox>
			)}
		>
			{children}
		</HtmlTooltip>
	);
};

export default BOMDetailsTooltip;
